export const formatCurrency = (amount: number, currency: string) => {
  const code = currency && typeof currency === 'string' ? currency : 'USD';
  try {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: code }).format(amount || 0);
  } catch {
    return `${code} ${Number(amount || 0).toLocaleString()}`;
  }
};
